import { useState, useContext, useEffect, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { Skeleton } from 'primereact/skeleton';
import AuthContext from '../../../auth/AuthContext';
import AlertService from '../../../services/AlertService';
import DocTypeCard from "./DocTypeCard";
import DocumentTypeService from "../../../services/DocumentTypeService";

const DocumentType = () => {
  const [fullDocTypes, setFullDocTypes] = useState([]);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const authContext = useContext(AuthContext);

  useEffect(() => {
    const documentAccess = authContext.getPermissions("documents") || [];
    if (documentAccess.filter(f => f.access.includes(1)).length === 0 || authContext.onGoingValidations) {
      navigate("/");
    }
  }, [navigate, authContext]);

  const loadDocumentTypes = useCallback(async () => {
    setLoading(true);
    const data = await DocumentTypeService.GetDocumentTags(authContext);
    if (data.isSuccess) {
      setFullDocTypes(Array.isArray(data.data) ? data.data : []);
    } else {
      AlertService.error(data.errorMessage);
    }
    setLoading(false);
  }, [authContext]);

  useEffect(() => {
    loadDocumentTypes();
  }, [loadDocumentTypes]);

  const handleClick = (title, id) => {
    const slug = title.toLowerCase().replace(/\s+/g, "-");
    navigate(`/document/${slug}`, { state: { title, value: id } });
  };

  return (
    <div className="container-fluid custom-container mt-3 pt-3">
      {/* {permissions.showAdd && (
        <div className="d-flex justify-content-end mb-3">
          <button className="btn btn-primary py-2" onClick={handleAddClick}>
            <FaPlus className="pb-1 me-1" />
            Add New Document Type
          </button>
        </div>
      )} */}

      <div className="row g-4 mb-4 ">
        {loading ? (
          Array.from({ length: 8 }).map((_, idx) => (
            <div key={idx} className="col-12 col-sm-6 col-md-4 col-lg-4 col-xl-3">
              <div className="card border-0 shadow-sm p-3 h-100 d-flex flex-row align-items-center gap-3">
                <Skeleton shape="circle" size="3rem" className="flex-shrink-0" />
                <div className="flex-grow-1">
                  <Skeleton width="80%" height="1.2rem" />
                </div>
              </div>
            </div>
          ))
        ) : fullDocTypes.length > 0 ? (
          fullDocTypes.map(document => (
            <div
              key={document.value}
              className="col-12 col-sm-6 col-md-4 col-lg-4 col-xl-3"
              onClick={() => handleClick(document.label, document.value)}
              style={{ cursor: "pointer" }}
            >
              <DocTypeCard
                title={`${document.label}`}
              />
            </div>
          ))
        ) : (
          <div className="col-12 text-center">No Document Types available...</div>
        )}
      </div>
    </div>
  );
};

export default DocumentType;
